// extracted by mini-css-extract-plugin
export default {"container":"SyncDirection_container__Af18a","image":"SyncDirection_image__LUU3f","icon":"SyncDirection_icon__9FDUM"};